import System from './System';
import GameObject from '../GameObject/GameObject';
import { Anim, AwaitIterators, GetAnimationClip, PlayAnimation } from './Animation/AnimationHelper';
import { SceneTransition } from '../Scene/SceneManager';
import RelativePositionComponent from '../Component/Render/RelativePosition';
import Point from '../Utility/Point';
import Game from '../Game';
import Container from '../Prototype/Container';
import AnimationComponent from '../Component/Animation';
import { AnimationClipEvent } from './Animation/AnimationClip';
import { GameActions } from '../State/Game/GameActions';
import { AsyncActionStatus } from '../State/AsyncAction';
import { IGameState } from '../State/Game/IGameState';
import { generifyPromise } from 'Utility/async';
import { setIsTransitioning } from 'Utility/isTransitioning';
import { PlinkoLoadingScreen } from 'Prototype/Effect/PlinkoLoadingScreen';
import { AUDIO_PATH, PlaySound } from './Audio/AudioHelper';

export default class PlinkoTransitionSystem extends System {
    public static LOADING_ANIMATION: string = 'loading_animation';
    public static LOADING_OVERLAY: string = 'loading_overlay';
    public static LOADING_BACKGROUND: string = 'loading_background';
    public container: Container;
    public transitionComplete: boolean = false;
    private loading: PlinkoLoadingScreen;

    public onStart(): void {
        this.scene.on(SceneTransition.START, () => {
            this.startCoroutine(this.transitionIn());
        });

        this.scene.on(SceneTransition.END, () => {
            this.startCoroutine(this.transitionOut());
        });

        PlaySound('plinko_transition');
    }
    private *transitionIn() {
        try {
            this.transitionComplete = false;
            this.createObjects();
            yield* AwaitIterators([
                PlayAnimation(
                    GetAnimationClip('ContainerFadeIn', this.container, {
                        startAlpha: 0,
                        endAlpha: 1,
                        duration: 300,
                    })
                        .on(AnimationClipEvent.DESTROY, this.transitionInComplete.bind(this, false))
                        .on(AnimationClipEvent.COMPLETE, this.transitionInComplete.bind(this, true))
                ),
                this.loading.animate(),
            ]);
        } catch (e) {
            console.error(e);
        }
    }
    private transitionInComplete(success: boolean): void {
        if (this.transitionComplete) return;
        if (success) {
            //Game.scene.getActiveScene().stop();
            this.scene.emit(SceneTransition.STARTED);
        } else {
            const state: IGameState = Game.store.getState();
            GameActions.setState({
                ...state,
                activeScene: {
                    ...state.activeScene,
                    status: AsyncActionStatus.QUEUED,
                },
            });
        }
        this.transitionComplete = true;
    }
    private *transitionOut() {
        this.loading.stopAnimation();
        yield* generifyPromise(Anim(this.container, { alpha: 0, duration: 1000 }));
        this.scene.emit(SceneTransition.ENDED);
        this.destroyObjects();
        setIsTransitioning(false);

        this.scene.unload();
    }
    private createObjects() {
        this.container = GameObject.Instantiate(Container, {
            name: 'PreloaderContainer',
            alpha: 0,
        });
        this.container.addComponent(RelativePositionComponent, {
            relativePosition: new Point(0.5, 0.5),
        });

        this.container.addComponent(AnimationComponent);

        this.loading = GameObject.Instantiate(PlinkoLoadingScreen, {});

        this.container.addChild(this.loading);

        this.scene.addGameObject(this.container);
    }

    private destroyObjects() {
        this.container.destroy();
    }

    public async preload(): Promise<any> {
        Game.resource.add('plinko_transition', `${AUDIO_PATH}plinko-minigame/plinko-minigame-transition.mp3`);

        return Game.resource.load();
    }

    public handleStateChanged(state: IGameState): void {}
    public init(params?: any): void {}
    protected onUpdate(): void {}
    protected onLateUpdate(): void {}
    protected onStop(): void {}
    protected onDestroy(): void {}
}
